<template>
  <SfListItem
    :id="`${id}-list-item`"
    :data-testid="`${id}-list-item`"
    :tag="tag"
    :size="size"
    class="rounded-md typography-text-base md:typography-text-sm"
  >
    <slot />
  </SfListItem>
</template>

<script setup lang="ts">
import type { ListItemProps } from '~/components/ui/ListItem/types';

withDefaults(defineProps<ListItemProps>(), { size: 'sm' });
</script>
